<button
  type="button"
  class="cookie-reopen"
  [class.oculto]="mostrarBanner"
  aria-label="Configurar preferencias de cookies"
  (click)="reabrir()"
>
  <svg viewBox="0 0 24 24" width="24" height="24" fill="currentColor">
    <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10c0-.34-.02-.67-.05-1a3 3 0 0 1-3.7-3.7A9.99 9.99 0 0 0 12 2zm-4 5a1.5 1.5 0 1 1 0 3 1.5 1.5 0 0 1 0-3zm7 1a1 1 0 1 1 0 2 1 1 0 0 1 0-2zM7.5 12A1.5 1.5 0 1 1 7.5 15 1.5 1.5 0 0 1 7.5 12zm5 2a1.5 1.5 0 1 1 0 3 1.5 1.5 0 0 1 0-3zm4.5 1a1 1 0 1 1 0 2 1 1 0 0 1 0-2z"/>
  </svg>
  <span class="cookie-tooltip">Configurar preferencias de cookies</span>
</button>

@if (mostrarBanner) {
  <div class="cookie-overlay">
    <div class="cookie-panel-background">
      <div class="cookie-panel">
        <div class="cookie-descripcion">
          <h5>Política de Cookies</h5>
          <p>
            UNIFERSA 2006 S.A. utiliza en este sitio web cookies propias técnicas necesarias para su funcionamiento, así
            como cookies de terceros con fines analíticos y de contenido multimedia que requieren tu consentimiento.
            Puedes aceptar todas las cookies, rechazar las no esenciales, o personalizar tu selección. Para más
            información, consulta nuestra <a [routerLink]="['/politica-cookies']">Política de Cookies</a>.
          </p>
        </div>
  
        @if (!mostrarConfigurador) {
          <div class="cookie-acciones">
            <button type="button" class="btn-aceptar" (click)="aceptarTodas()">Aceptar todas</button>
            <button type="button" class="btn-rechazar" (click)="rechazarNoEsenciales()">Rechazar</button>
            <button type="button" class="btn-configurar" (click)="abrirConfigurador()">Configurar Cookies</button>
          </div>
        } @else {
          <div class="cookie-tipos">
            <h6>¿Qué cookies quieres aceptar?</h6>
  
            <div class="cookie-tipo">
              <dx-check-box class="necesarias"
                text="Necesarias"
                [value]="true"
                [disabled]="true"
              >
              </dx-check-box>
              <p>Necesarias para el funcionamiento básico del sitio (sesión, formularios, visualización de productos).</p>
            </div>
  
            <div class="cookie-tipo">
              <dx-check-box
                text="Análisis (Google Analytics)"
                [(value)]="preferencias.analisis"
              >
              </dx-check-box>
              <p>Permiten medir el uso del sitio web para mejorar su rendimiento y contenido.</p>
            </div>
  
            <div class="cookie-tipo">
              <dx-check-box
                text="Contenido de terceros (YouTube, Google Maps, redes sociales)"
                [(value)]="preferencias.terceros"
              >
              </dx-check-box>
              <p>Habilitan la visualización de vídeos, mapas y botones de compartir en redes sociales.</p>
            </div>
          </div>
          
          <div class="cookie-acciones">
            <button type="button" class="btn-aceptar" (click)="guardarConfiguracion()">Guardar preferencias</button>
            <button type="button" class="btn-rechazar" (click)="rechazarNoEsenciales()">Aceptar solo necesarias</button>
          </div>
        }
      </div>
    </div>
  </div>
}
